import { Component } from 'preact'
/* eslint-disable import/no-internal-modules */
import { PaginationProps } from '@insided/deprecated-control/ui-components/PaginationComponent'
import { Author, Reply, Topic } from '../../interfaces'
import ReplyPost from './ReplyPost'
import { ContentType } from '@insided/shared/utils/contentType'
import { filterSelectedReplies, toggleReplyOnTrash } from '../../utils'
import RepliesHeader from './RepliesHeader'
import RepliesFooter from './RepliesFooter'
import { ParentCategory } from '@insided/deprecated-preact-components/category-selector/CategorySelector'

interface Props {
  replyCount: number
  replies: Reply[]
  repliesPagination: PaginationProps
  getReplies: (page?: number, pageSize?: number, sort?: string) => Promise<any>
  repliesSorting: string
  author: Author
  pinnedReplyId?: string | null
  contentType: ContentType
  topic: Topic
  title: string
  handleShowAlert: (type: 'success' | 'error', message?: string) => void
  handleToggleSpamModal: (replyId?: string) => void
  selectedReplies: string[]
  destinationUrl: string
  isProductboardNoteCreationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
  setSelectedReplies: (selectedReplies: string[]) => void
  setReplies: (replies: Reply[]) => void
  setRepliesSorting: (repliesSorting: string) => void
  onTogglePin: (reply: Reply) => (pinnedReplyId: string | null) => void
  categories: ParentCategory[]
}

class Replies extends Component<Props> {
  constructor(props: Props) {
    super(props)
    this.onSelectReply = this.onSelectReply.bind(this)
    this.onToggleTrash = this.onToggleTrash.bind(this)
  }

  onSelectReply(selectedReplyId: string) {
    const { selectedReplies, setSelectedReplies } = this.props
    const replies = selectedReplies.includes(selectedReplyId)
      ? filterSelectedReplies(selectedReplies, selectedReplyId)
      : [...selectedReplies, selectedReplyId]
    setSelectedReplies(replies)
  }

  onToggleTrash = (replyId: string) => {
    const { replies, selectedReplies, setSelectedReplies, setReplies } = this.props
    const updatedReplies = toggleReplyOnTrash(replies, replyId)
    const updatedSelectedReplies = filterSelectedReplies(selectedReplies, replyId)
    setSelectedReplies(updatedSelectedReplies)
    setReplies(updatedReplies)
  }

  render() {
    const {
      replyCount,
      replies,
      repliesPagination,
      getReplies,
      repliesSorting,
      author,
      pinnedReplyId,
      contentType,
      topic,
      title,
      handleShowAlert,
      handleToggleSpamModal,
      destinationUrl,
      isProductboardNoteCreationEnabled,
      isZendeskTicketEscalationEnabled,
      isSalesforceCaseEscalationEnabled,
      isFreshdeskTicketEscalationEnabled,
      setRepliesSorting,
      onTogglePin,
      selectedReplies,
      categories
    } = this.props

    return (
      <div className='topic-moderation--replies'>
        <RepliesHeader
          replyCount={replyCount}
          replies={replies}
          repliesPagination={repliesPagination}
          getReplies={getReplies}
          repliesSorting={repliesSorting}
          setRepliesSorting={setRepliesSorting}
        />
        {replies.map((reply: Reply, index: number) => (
          <ReplyPost
            {...reply}
            isAuthor={reply.author.id === author.id}
            isPinned={pinnedReplyId === reply.id}
            replyNumber={
              repliesPagination.page && repliesPagination.pageSize
                ? index + repliesPagination.pageSize * (repliesPagination.page - 1) + 1
                : 0
            }
            replyCount={replyCount}
            contentType={contentType}
            topicId={topic.id}
            topicPublicId={topic.publicId}
            topicTitle={title}
            onShowAlert={handleShowAlert}
            onTogglePin={onTogglePin(reply)}
            likedBy={reply.likedBy}
            key={reply.id}
            onToggleSpam={handleToggleSpamModal}
            selectedReplies={selectedReplies}
            onSelectReply={this.onSelectReply}
            destinationUrl={destinationUrl}
            onToggleTrash={this.onToggleTrash}
            isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
            isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
            isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
            isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
            getReplies={getReplies}
            categories={categories}
          />
        ))}
        <RepliesFooter
          replies={replies}
          repliesPagination={repliesPagination}
          getReplies={getReplies}
          repliesSorting={repliesSorting}
          setRepliesSorting={setRepliesSorting}
        />
      </div>
    )
  }
}

export default Replies
